import React from 'react';
import { Tabs } from 'antd';
import { InvalidUrlPage } from '@components/error-page';
import { ApimPageShell } from '@pages/api-portal/apim-page-shell';
import { PageLoader } from '@pages/api-portal/page-loader';
import { useCatalogDetail } from './use-catalog-detail';
import { ApiDetailHeader } from './api-detail-header';
import { ParametersTable } from './parameters-table';
import { ResponseExamples } from './response-examples';
import { CurlExampleCard } from './curl-example-card';
import { TryItOutConsole } from './try-it-out-console';

/*
 * API Catalog detail screen — endpoint documentation (parameters/responses/cURL) alongside
 * a live Try It Out console.
 */
export function CatalogDetailScreen() {
    const { endpoint, isLoading, notFound } = useCatalogDetail();

    if (notFound || (!endpoint && !isLoading)) return <InvalidUrlPage />;

    return (
        <ApimPageShell navSelectedId="apim" navType="others">
            {isLoading || !endpoint ? (
                <PageLoader />
            ) : (
                <>
                    <ApiDetailHeader endpoint={endpoint} />
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <Tabs defaultActiveKey="parameters">
                                <Tabs.TabPane tab="Parameters" key="parameters">
                                    <ParametersTable endpoint={endpoint} />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Responses" key="responses">
                                    <ResponseExamples responses={endpoint.responses} />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Examples" key="examples">
                                    <CurlExampleCard endpoint={endpoint} />
                                </Tabs.TabPane>
                            </Tabs>
                        </div>
                        <div style={{ width: 380, flexShrink: 0 }}>
                            <TryItOutConsole endpoint={endpoint} />
                        </div>
                    </div>
                </>
            )}
        </ApimPageShell>
    );
}
